import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("treaf4wWBBty3fHdyBpo35Mz84M8k3heKXmjmi9vFt5");
//# sourceMappingURL=constants.js.map